import React from "react"
import "./socialLinks.css"
import Tooltip from "./tooltip"

const SocialLinks = props => {
  const { svgFiles, links } = props

  return (
    <div className="social-links">
      {links.map((link, i) => {
        // fetches the image based on the value that that is set on the appropriate json element
        const iconForLink = svgFiles.edges.find(element => {
          return element.node.name === link.filename
        })

        if (iconForLink) {
          return (
            <React.Fragment key={i}>
              <Tooltip content={link.tooltip}>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={link.url}
                  aria-label={link.tooltip}
                >
                  <img src={iconForLink.node.publicURL} alt="" />
                </a>
              </Tooltip>
            </React.Fragment>
          )
        }

        return <React.Fragment key={i} />
      })}
    </div>
  )
}
export default SocialLinks
